import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";
import { BsModalService } from "ngx-bootstrap/modal";
import { NotificationAlertService } from "src/app/services/notification.service";
import { ApiService } from "src/app/services/api.service";
import { DataTransferService } from "src/app/services/data-transfer.service";
import { AFTER_PIN_SUCCESS } from "src/app/global/constants";
import { TransactionDetailComponent } from "src/app/pages/merchant/analytics/transaction-detail/transaction-detail.component";
import { TransactionTemplateDetailComponent } from "src/app/pages/merchant/transactions/template-detail/transaction-template-detail.component";

@Component({
  selector: "app-success-component",
  templateUrl: "./success-component.component.html",
  styleUrls: ["./success-component.component.scss"],
})
export class SuccessComponentComponent implements OnInit {
  type: string;
  apiData: any;
  backUrl = "";
  title = "";
  viewingPaymentDetail = false;
  transactionPath = "home/transaction";
  payrollPath = "home/payroll";
  isPayroll: boolean = false;
  viewDetailsLinkName = "View payment details";
  isShowViewDetailsLink: boolean = true;

  constructor(
    private router: Router,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private notification: NotificationAlertService,
    private api: ApiService,
    public dataService: DataTransferService,
    public browserLocation: Location,
  ) {}

  ngOnInit() {
    this.dataService.transactionDoneFromObs.subscribe((processData) => {
      this.type = processData.type;
      this.apiData = processData.data;
      this.backUrl = processData.path;
      if (processData.data?.isPayroll) {
        this.isPayroll = processData.data.isPayroll;
      }
    });
    this.setTitle();
  }

  setTitle() {
    this.viewDetailsLinkName = "View payment details";
    if (this.type) {
      switch (this.type) {
        case AFTER_PIN_SUCCESS.ADD_MONEY_WALLET:
          this.title = "Money added to wallet successfully";
          break;
        case AFTER_PIN_SUCCESS.SEND_MONEY_WALLET:
        case AFTER_PIN_SUCCESS.SEND_MONEY_CARD:
          this.title = "Transfer successful!";
          break;
        case AFTER_PIN_SUCCESS.REQUEST_MONEY:
          this.title = "Request Submitted";
          break;
        case AFTER_PIN_SUCCESS.TRANSFER_TO_BANK:
          this.title = "Transfer successful!";
          break;
        case AFTER_PIN_SUCCESS.TOP_UP:
          this.title = "Top-up successful!";
          break;
        case AFTER_PIN_SUCCESS.PAYROLLTOALL:
          this.title = "Payroll pay to all successful!";
          this.isShowViewDetailsLink = false;
          break;
        case AFTER_PIN_SUCCESS.SEND_MONEY_WALLET_TEMPLATE:
          this.title = "Template created successful!";
          this.isShowViewDetailsLink = false;
          break;
        case AFTER_PIN_SUCCESS.SEND_PATCH_SCHEDULE_PAYROLL:
          this.title = "Payroll batch scheduled successfully!";
          this.isShowViewDetailsLink = false;
          break;
        default:
          break;
      }
    } else {
      this.router.navigate(["/"]);
    }
  }
  goBack() {
    console.log("this.backUrl", this.backUrl);
    console.log("this.transactionPath", this.transactionPath);
    if (this.backUrl == "") {
      if (!this.isPayroll) {
        this.router.navigate([`/${this.transactionPath}`]);
      } else {
        this.router.navigate([`/${this.payrollPath}`], {
          queryParams: { tab: 1 },
        });
      }
    } else {
      this.router.navigate([this.backUrl]);
    }
  }

  async cancelRequest() {
    this.spinner.show();
    const response: any = await this.api.post(
      "payment/money/cancel-request",
      { requestId: this.apiData.id },
      true,
    );
    if (response) {
      this.notification.showSuccess(response.message);
      this.router.navigate([this.backUrl]);
    }
  }
  viewDetails() {
    // Display a different popup based on the type of transaction
    if (this.apiData.isScheduled && this.apiData?.id) {
      const initialState = {
        templateId: this.apiData?.id,
      };
      this.modalService.show(TransactionTemplateDetailComponent, {
        class: "tansaction-modals",
        initialState,
      });
    } else {
      const initialState = {
        transactionId: this.apiData.transId,
      };
      this.modalService.show(TransactionDetailComponent, {
        class: "tansaction-modals",
        initialState,
      });
    }
  }
}
